import { useState } from 'react';

/**
 * Hook for managing tab navigation state
 * Handles active tab state and tab switching logic
 */
export const useTabNavigation = (initialTab = 'general') => {
  const [activeTab, setActiveTab] = useState(initialTab);

  const switchTab = (tabId) => {
    setActiveTab(tabId);
  };

  return {
    activeTab,
    setActiveTab,
    switchTab
  };
};

export default useTabNavigation;